import { Component } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Checkbox, FormControlLabel, Stack, Typography,
    CircularProgress, IconButton
} from "@mui/material";
import { MdClose, MdOutlineClose } from "react-icons/md";
import { httpGet } from "../util/http";

export default class ProdutosAbertosDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            produtos: [],
            selecionados: {},
        };
    }

    componentDidMount() {
        this.carregarProdutos();
    }

    carregarProdutos() {
        this.setState({ loading: true });
        httpGet('/inventarios/' + this.props.depositoId + '/produtosabertos',
            produtos => {
                this.setState({
                    produtos: produtos || [],
                    loading: false,
                });
                //console.log(produtos)
            },
            error => {
                console.log(error);
                this.setState({ loading: false, produtos: [] });
            },
        );
    }

    chave(produto) {
        return produto.codigo + '-' + produto.derivacao;
    }

    toggleProduto(produto) {
        const key = this.chave(produto);
        this.setState(prevState => ({
            selecionados: {
                ...prevState.selecionados,
                [key]: !prevState.selecionados[key],
            }
        }));
    }

    handleEncerrar() {
        const produtosSelecionados = this.state.produtos.filter(
            p => this.state.selecionados[this.chave(p)]
        );
        if (this.props.onConfirm) {
            this.props.onConfirm(produtosSelecionados);
        }
    }

    render() {
        const totalSelecionados = Object.values(this.state.selecionados).filter(Boolean).length;

        return (
            <Dialog open={true} onClose={() => this.props.onClose()} maxWidth="sm" fullWidth>
                <DialogTitle color="primary" fontSize={12}><b>Produtos em aberto</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose(e)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent dividers>
                    {this.state.loading ?
                        <Stack alignItems="center" p={3}><CircularProgress /></Stack> :
                        this.state.produtos.length === 0 ?
                            <Typography variant="body2" color="text.secondary">
                                Não há produtos em aberto para este depósito.
                            </Typography> :
                            <Stack gap={0.5}>
                                <Typography variant="caption" color="text.secondary">
                                    Selecione os produtos que deseja encerrar. Produtos não selecionados permanecerão em aberto.
                                </Typography>
                                {this.state.produtos.map(produto => (
                                    <FormControlLabel
                                        key={this.chave(produto)}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={!!this.state.selecionados[this.chave(produto)]}
                                                onChange={() => this.toggleProduto(produto)}
                                            />
                                        }
                                        label={
                                            <Typography variant="caption" fontSize={'13px'}>
                                                {produto.codigo + '/' + produto.derivacao + ' - ' + produto.descricao}
                                            </Typography>
                                        }
                                    />
                                ))}
                            </Stack>
                    }
                </DialogContent>
                <DialogActions>
                    <Typography variant="caption" color="text.secondary" sx={{ flex: 1, ml: 1 }}>
                        {totalSelecionados} produto(s) selecionado(s)
                    </Typography>
                    <Button onClick={() => this.props.onClose()} size="small">Cancelar</Button>
                    <Button
                        onClick={() => this.handleEncerrar()}
                        color="error"
                        variant="contained"
                        size="small"
                        disableElevation
                        disabled={this.state.loading || totalSelecionados === 0 || this.props.btnLoading}
                        startIcon={this.props.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : null}
                    >
                        Encerrar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}